export default __webpack_public_path__ + "images/4ceb079f8fe3ce03779d672d7ee3d4d9.svg";